export const text = {
  login: 'Change Password',
  pageTitle: 'Change Password',
};
